import API_ENDPOINTS from "../config/apiEndpoints";
import { ensureOk, requestWithAuth } from "./apiClient";

export const apiAusenciasService = {
  getByAnnoAndMesAndEmpleadoId: async (anno, mes, empleadoId) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.AUSENCIA.ALL_BY_ANNO_MES_AND_EMPLEADO_ID(anno, mes, empleadoId)
    );
    ensureOk(response, "Error al obtener la lista de ausencias");

    return response.json();
  },
  create: async (ausencia) => {
    const response = await requestWithAuth(API_ENDPOINTS.AUSENCIA.CREATE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(ausencia),
    });

    return response;
  },
  createDesdeHasta: async (
    tipo,
    empleadoId,
    descripcion_id,
    fechaDesde,
    fechaHasta
  ) => {
    const body = {
      empleadoId,
      fechaDesde,
      fechaHasta,
      tipo,
    };

    if (descripcion_id !== null && descripcion_id !== undefined) {
      body.descripcion_id = descripcion_id;
    }

    const response = await requestWithAuth(API_ENDPOINTS.AUSENCIA.CREATE_DESDE_HASTA, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    ensureOk(response, "Error crear ausencia");

    return response.json();
  },
  delete: async (id) => {
    const response = await requestWithAuth(API_ENDPOINTS.AUSENCIA.ONE(id), {
      method: "DELETE",
    });
    ensureOk(response, "Error al eliminar una ausencia");
    return response;
  },
  getComputo: async (idEmpleado, anno) => {
    const response = await requestWithAuth(API_ENDPOINTS.AUSENCIA.COMPUTO(idEmpleado, anno));
    ensureOk(response, "Error en la descarga del computo de horas anual");
    return response.json();
  },

  getIncidenciasVacaciones: async (idEmpresa, anno) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.AUSENCIA.INCIDENCIAS_VACACIONES(idEmpresa, anno)
    );
    ensureOk(response, "Error en la obtener incidencias en las vacaciones");
    return response.json();
  },
  getIncidenciasDepartamento: async (idEmpresa, anno) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.AUSENCIA.INCIDENCIAS_DEPARTAMENTO(idEmpresa, anno)
    );
    ensureOk(response, "Error en la obtener incidencias en departamentos");
    return response.json();
  },
  getComputoEmpleado: async(idEmpleado, year) => {
    return requestWithAuth(API_ENDPOINTS.AUSENCIA.COUNT_AUSENCIAS_MOTIVO_IN_YEAR(idEmpleado, year));
  }    ,
};
